import { combineReducers } from "redux";
import { tournaments } from "./tournaments";

export const rootReducer = combineReducers({
  tournaments,
});

